import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import AdminAction from './AdminAction';

/**
 * Standardized delete confirmation dialog used across all admin listing pages.
 */
export default function DeleteConfirmationDialog({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Deletion',
  message,
  itemName,
  loading = false,
  confirmLabel = 'Delete',
}) {
  const defaultMessage = itemName ? (
    <>
      Are you sure you want to delete{' '}
      <strong style={{ color: '#1c1917' }}>{itemName}</strong>? This action cannot be undone.
    </>
  ) : (
    'Are you sure you want to delete this item? This action cannot be undone.'
  );

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: '12px' } }}
      aria-labelledby="delete-confirmation-title"
    >
      <DialogTitle
        id="delete-confirmation-title"
        sx={{
          fontWeight: 700,
          pb: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {title}
        <IconButton
          onClick={onClose}
          disabled={loading}
          size="small"
          aria-label="Close dialog"
          sx={{ color: '#78716c' }}
        >
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: '#57534e' }}>
          {message ?? defaultMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <AdminAction variant="outline" onClick={onClose} disabled={loading}>
          Cancel
        </AdminAction>
        <AdminAction
          variant="dangerSolid"
          onClick={onConfirm}
          loading={loading}
          sx={{ minWidth: 80 }}
        >
          {confirmLabel}
        </AdminAction>
      </DialogActions>
    </Dialog>
  );
}
